export const LETTER_SCORES: Record<string, number> = {
A:1, B:3, C:3, D:2, E:1, F:4, G:2, H:4, I:1,
J:8, K:5, L:1, M:3, N:1, O:1, P:3, Q:10, R:1,
S:1, T:1, U:1, V:4, W:4, X:8, Y:4, Z:10
};
export type ScorePart = { letter: string; value: number; isBlank: boolean };
export function normalizeWord(input: string): string {
return input
.replace(/[^\p{L}*?]/gu, "") // keep letters + '*'/'?' as blanks
.toUpperCase();
}
/**
* '*' or '?' = blank tile (0 points). Letters outside A–Z are ignored.
*/
export function scoreWord(input: string): { total: number; parts: ScorePart[] } {
const word = normalizeWord(input);
const parts: ScorePart[] = [];
let total = 0;
for (const ch of word) {
if (ch === "*" || ch === "?") {
parts.push({ letter: ch, value: 0, isBlank: true });
continue;
}
const val = LETTER_SCORES[ch] ?? 0;
parts.push({ letter: ch, value: val, isBlank: false });
total += val;
}
return { total, parts };
}